import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import auth from './auth-slice'
import datasources, { fetchDatasources } from './datasources-slice'
import ui from './ui-slice'
import values, { fetchValues } from './values-slice'
import featuredTags from './featured-tags-slice'
import customerImpactSlice from './customer-impact-slice'
import accountsSlice from './accounts-slice'

const rootReducer = combineReducers({
  auth,
  datasources,
  featuredTags,
  customerImpactSlice,
  ui,
  values,
  accountsSlice
})

const store = configureStore({
  reducer: rootReducer,
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const hydrateServer = (_store) => [
  _store.dispatch(fetchValues()),
  _store.dispatch(fetchDatasources())
]
